import React from 'react';

require('style/Control');

export default class Control extends React.Component {
  render() {
    return (
      <div className="Control">
        <label>{this.props.label}</label>
        <div className="controlItem">
          {this.props.children}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/components/Control.js